/* eslint-disable react/jsx-no-target-blank */
import 'bootstrap/dist/css/bootstrap.min.css'
import { useEffect, useState, useRef } from 'react'
import axios from 'axios'

function CercaFornitore({ dettagliIsOpen, flag, dati }) {
    const [formData, setFormData] = useState('')
    const [fornitore, setFornitore] = useState({})
    const [fornitoriTrovati, setFornitoriTrovati] = useState([])
    const [msgEsitoQuery, setMsgEsitoQuery] = useState({ msgTipologiaPredef: null })
    const [msgCity, setMsgCity] = useState({ city: '', genere: '' })
    const [cityFilter, setCityFilter] = useState([])//città/regione filtrate ad ogni change dell'input 'città'
    const [generiFilter, setGeneriFilter] = useState([])//genere/nome filtrati ad ogni change dell'input
    const [città, setCittà] = useState([])// città/regioni trovate in MYSQL 
    const [generi, setGeneri] = useState([])// generi/nomi trovati in MYSQL 
    const [mode, setMode] = useState({ luogo: '', mode: '' })// ricerca con tipologia o con città
    const [scelta, setScelta] = useState("")

    const genereValue = useRef()
    const cittàValue = useRef()
    const cercaPerCittàDiv = useRef()// div del cerca fornitore per città o regione

    function handleChangeCittà(e) {//RICERCA PER CITTA O REGIONE
        const { value } = e.target
        setFormData({ città: value }); setMsgEsitoQuery({ msgTipologiaPredef: null }); setGeneriFilter([])
        let filter = []
        città.some((elem, index) => {//filtraggio città da input 
            if (value.toLowerCase() !== '') {
                if (elem.toLowerCase().includes(value.toLowerCase())) {//match tra input 'città' e array città
                    filter.push(elem)
                }
            }
        })
        if (filter.length > 0) {//se in input 'città' viene trovata una città in array 'citta'
            filter = filter.filter((value, index) => filter.indexOf(value) === index)//tolgo le città ripetute
            setCityFilter(filter)
        }
        setMsgCity(x => ({ ...x, city: filter.length === 0 && value ? '*** Nessuna città trovata ***' : '' }))
    }
    const cittàCliccata = (elem) => {//QUANDO CLICCO UNA CITTA DA BANNER CITTA TROVATE
        cittàValue.current.value = elem
        setFormData({ ...formData, città: elem })

        const fornitoreByGenere = fornitore.filter(item =>
            (item.città.toUpperCase() === elem.toUpperCase() || item.regione.toUpperCase() === elem.toUpperCase()) && (item.accettazione === 'true'))
        if (fornitoreByGenere.length === 0) {
            setMsgCity({ city: `Nessun fornitore trovato a ${elem}` })
            return
        }
        setFornitoriTrovati(fornitoreByGenere)//città trovata
        setMode({ luogo: elem, mode: 'città' })
        dettagliIsOpen('flag1')
    }
    const genereCliccato = (elem) => {//QUANDO CLICCO UN ELEM DA BANNER GENERE/NOME
        const fornitoreByGenere = fornitore.filter(item =>
            (item.genere.toUpperCase() === elem.toUpperCase() || item.gruppo.toUpperCase() === elem.toUpperCase() || item.nome?.toUpperCase() === elem.toUpperCase()) && (item.accettazione === 'true'))
        if (fornitoreByGenere.length === 0) {
            setMsgCity({ city: `Nessun fornitore trovato a ${elem}` })
            return
        }
        setFornitoriTrovati(fornitoreByGenere)
        setMode({ luogo: elem, mode: 'città' })
        dettagliIsOpen('flag1')
    }
    function handleChangeGenere(e) {// GENERE/NOME DA INPUT
        const { value } = e.target
        setMsgEsitoQuery({ msgTipologiaPredef: null, msgTipologiaInput: null })
        setCityFilter([])
        let filter = []
        if (value.toLowerCase() !== '') {
            generi.some((elem, index) => {//filtraggio generi/nomi da input 
                if (elem?.toLowerCase().includes(value.toLowerCase())) {
                    filter.push(elem)
                }
            })
        }; console.log('filter:', filter.length)
        if (filter.length > 0) {//se dall'input viene trovata una corrisdpondenza
            filter = filter.filter((value, index) => filter.indexOf(value) === index)//tolgo gli elementi ripetuti 
        }
        setGeneriFilter(filter)
        setMsgCity(x => ({ ...x, genere: filter.length === 0 && value ? '*** Nessuna elemento trovato ***' : '' }))
    }
    function handleChangeSelect(e) {//cerca dal select (tipicizzata)
        setMsgEsitoQuery({ msgTipologiaPredef: null }); setCityFilter([]); setGeneriFilter([])
        const { value, type, checked } = e.target//attributi degli input
        const inputValue = type === "checkbox" ? checked : value
        setScelta(inputValue)
        getFornitori(inputValue, 'msgTipologiaPredef')
    }
    async function getFornitori(inputValue, msgTipologia) {
        const fornitoreByGenere = fornitore.filter(x => x.genere === inputValue)
        if (fornitoreByGenere.length === 0) {
            setMsgEsitoQuery({ [msgTipologia]: '*** Nessun fornitore trovato ***' })
        } else {//fornitore trovato da select: apro il banner 'flag1'
            setFornitoriTrovati(fornitoreByGenere)
            setMode({ mode: 'genere' })
            dettagliIsOpen('flag1')
        }
    }

    useEffect(() => {//caricamento Città Regione da server nodejs (MYSQL)
        let arr = []; let arr2 = []
        axios.post('/getArtisti/DESC/id').then(res => {
            setFornitore(res.data.filter(item => item.sezione === "fornitore"))
            const response = res.data
            response.forEach(element => {//carico 'setCittà' con le città presenti in MYSQL
                if (element.sezione === 'fornitore') {
                    arr.push(element.città, element.regione)
                    arr2.push(element.genere, element.gruppo, element.nome)
                }
            })
            setCittà(arr); setGeneri(arr2)
        })
    }, [])

    // useEffect(() => { console.log('generiFilter:', generiFilter) }, [generiFilter])

    return (<>
        <div className='container' style={{ backgroundColor: 'whitesmoke', marginTop: '3rem' }}>
            <hr />
            <div style={{ margin: '2rem 0' }}>
                <h3 style={{ textAlign: 'center' }}>TROVA FORNITORE</h3>

                {/* ---------------------- CERCA PER TIPOLOGIA PREDEFINITA -------------------- */}
                <div className="input-group mb-3" style={{ height: '36px' }}>
                    <div className='cercaArtistiDiv' style={{ border: '1px solid grey' }}>
                        <img src="https://img.icons8.com/?size=100&id=59878&format=png&color=000000"
                            className='cercaArtisti' alt='' />
                    </div>
                    <select style={{ border: '1px solid grey', padding: '0 10px', width: '85%' }}
                        name="tipologia" onChange={handleChangeSelect} value={scelta}>
                        <option value="" disabled>Seleziona un fornitore</option>
                        <option value="Agenzia di artisti">Agenzia di artisti</option>
                        <option value="Allestimenti floreali">Allestimenti floreali</option>
                        <option value="Event Planner/Organizer">Event Planner/Organizer</option>
                        <option value="Fornitore di tende e tessuti">Fornitore di tende e tessuti</option>
                        <option value="Impiantista elettrico">Impiantista elettrico</option>
                        <option value="Montaggio palchi/passerelle">Montaggio palchi/passerelle</option>
                        <option value="Noleggio arredi/tavoli/sedie">Noleggio arredi/tavoli/sedie</option>
                        <option value="Noleggio gazebo/tensostrutture">Noleggio gazebo/tensostrutture</option>
                        <option value="Noleggio gonfiabili">Noleggio gonfiabili</option>
                        <option value="Noleggio giochi per bambini">Noleggio giochi per bambini</option>
                        <option value="Pista stradale per bambini">Pista stradale per bambini</option>
                        <option value="Scenografi e decoratori">Scenografi e decoratori</option>
                        <option value="Security Service">Security Service</option>
                        <option value="Service Amplificazione/Microfoni">Service Amplificazione/Microfoni</option>
                        <option value="Service Audio/Video/Luci">Service Audio/Video/Luci</option>
                        <option value="Servizio Catering">Servizio Catering</option>
                        <option value="Tappeto elastico per bambini">Tappeto elastico per bambini</option>
                    </select>
                </div>
                {msgEsitoQuery.msgTipologiaPredef && <p style={{ color: 'red' }}><i>{msgEsitoQuery.msgTipologiaPredef}</i></p>}

                {/* ---------------- CERCA CON CHIAVE NOME/GENERE ---------------------------------------------------------------------------------------- */}
                <div className="input-group mb-3">
                    <div className='cercaArtistiDiv' style={{ border: '1px solid grey' }}>
                        <img src="https://img.icons8.com/?size=100&id=59878&format=png&color=000000"
                            className='cercaArtisti' alt='' />
                    </div>
                    <input ref={genereValue} style={{ display: 'inline', border: '1px solid grey', width: '85%', padding: '5px' }}
                        type='text'
                        placeholder='Nome/genere'
                        onChange={handleChangeGenere}
                        maxLength={45} />
                    <button style={{ float: 'right', fontSize: '18px', marginLeft: '-25px' }} onClick={() => {
                        setGeneriFilter([]); genereValue.current.value = ''
                    }}>X
                    </button>
                </div>
                {/* ----------------- BANNER GENERI/NOMI TROVATI ---------------------------------------------------------------------------------------- */}
                {generiFilter.length !== 0 &&
                    <div style={{
                        border: '1px solid black', zIndex: '1', padding: '5px', position: 'absolute', left: '6%', width: '14em', backgroundColor: 'whitesmoke'
                    }}>
                        <img src={require('../image/icons8-chiudi-macos-32.png')} alt='' style={{ cursor: 'pointer', float: 'right' }} onClick={
                            () => { setGeneriFilter([]) }
                        } /><br />
                        {generiFilter &&
                            generiFilter.map((elem, index) => (
                                <span className='filterCity' key={index}>
                                    <p style={{ cursor: 'pointer', fontSize: 'medium', margin: '-5px 3px' }} onClick={() => { genereCliccato(elem) }}>
                                        {elem.toUpperCase()}
                                    </p>
                                    {generiFilter.length !== index + 1 && <hr />}
                                </span>
                            ))
                        }
                    </div>
                }
                {msgCity.genere && <p style={{ color: 'red' }}><i>{msgCity.genere}</i></p>}
                <div className='text-center'>
                    <button className='btn btn-success' type='button' onClick={() => {
                        if (cercaPerCittàDiv.current.style.display === 'block') {
                            cercaPerCittàDiv.current.style.display = 'none'
                        }
                        else { cercaPerCittàDiv.current.style.display = 'block'; setMsgCity({ city: '' }) }
                    }}>CERCA PER REGIONE O CITTA'
                    </button>
                </div>

                {/* ---------------- CERCA CON CHIAVE CITTA'/R -------------------------------------------------------------------------------------------- */}
                <div ref={cercaPerCittàDiv} style={{ display: 'none' }}>
                    <div className="input-group mb-1 mt-2">
                        <div className='cercaArtistiDiv' style={{ border: '1px solid grey' }}>
                            <img src="https://img.icons8.com/?size=100&id=59878&format=png&color=000000"
                                className='cercaArtisti' alt='' />
                        </div>
                        <input ref={cittàValue} style={{ display: 'inline', border: '1px solid grey', width: '85%', padding: '5px' }}
                            type='text'
                            name='città'
                            placeholder='Es. Lazio'
                            onChange={handleChangeCittà} />
                        <button style={{ float: 'right', fontSize: '18px', marginLeft: '-25px' }} onClick={() => {
                            setCityFilter([]); cittàValue.current.value = ''
                        }}>X
                        </button>
                    </div>
                    <div>
                        {msgCity.city && <p style={{ color: 'red' }}><i>{msgCity.city}</i></p>}
                    </div>
                </div>

                {/* ----------------- BANNER CITTA' TROVATE ------------------------------------------------------------------------------------------------ */}
                {cityFilter.length !== 0 &&
                    <div style={{
                        border: '1px solid black', zIndex: '1', padding: '5px', position: 'absolute', left: '6%', width: '14rem', backgroundColor: 'whitesmoke'
                    }}>
                        <img src={require('../image/icons8-chiudi-macos-32.png')} alt='' style={{ cursor: 'pointer', float: 'right' }} onClick={
                            () => { setCityFilter([]) }
                        } /><br />
                        {cityFilter.length !== 0 &&
                            cityFilter.map((elem, index) => (
                                <span className='filterCity' key={index}>
                                    <p style={{ cursor: 'pointer', fontSize: 'medium', margin: '-6px 0' }} onClick={() => { cittàCliccata(elem) }}>
                                        {elem.toUpperCase()}
                                    </p>
                                    {cityFilter.length !== index + 1 && <hr />}
                                </span>
                            ))}
                    </div>
                }
            </div>
            <hr />
        </div><br />


        {/* --------------------- BANNER FORNITORI DOPO LA RICERCA ------------------------------------------------------------------------------------------- */}
        <div className='visualDettagli' style={{ top: `${flag === 'flag1' || flag === 'fornitoriDetails' ? '0' : '120%'}` }}>
            {fornitoriTrovati.length !== 0 &&
                <div style={{ padding: '1em 0' }}>
                    <span onClick={() => { window.history.back() }}
                        style={{ marginRight: '1.5em', fontSize: 'xx-large', cursor: 'pointer' }}>◁
                    </span>
                    <h2 style={{ display: 'inline', fontWeight: '600', fontFamily: 'sans-serif', textAlign: 'center' }}>
                        Fornitori/Servizi
                    </h2>
                    <div className='text-center'>
                        {mode.mode === 'genere' ?
                            <span>Trovati {fornitoriTrovati.length} come <i>{fornitoriTrovati[0].genere}</i></span>
                            : mode.mode === 'città' ?
                                <span>Trovati {fornitoriTrovati.length} in <i>{mode.luogo}</i></span> : null
                        }
                    </div>
                </div>
            }
            <hr />
            <div className='bodyPadding' style={{ overflowY: 'scroll', height: '78%', scrollBehavior: 'smooth' }}>
                {fornitoriTrovati &&
                    fornitoriTrovati.reverse().filter(item => (item.accettazione === 'true'))
                        .map(elem => {
                            let arrImg
                            if (elem.img) arrImg = elem.img.split(',')
                            return (
                                <div key={elem.id} className='p-1'>
                                    {elem.img &&
                                        <img src={`https://leuro-bucket.s3.amazonaws.com/${arrImg[0]}`}
                                            style={{ width: '70px', height: '70px', objectFit: 'cover', borderRadius: '50%' }} alt='' />
                                    }
                                    {/* ----------- NOME AZIENDA -------------------- */}
                                    {elem.gruppo && <p className='fw-semibold fs-4 mt-2'>{elem.gruppo.toUpperCase()}</p>}
                                    {/* -------------- NOME E COGNOME ---------------- */}
                                    {elem.nome && <p style={{ fontFamily: 'Times New Roman' }} className='mt-1'>
                                        {elem.nome} {elem.cognome}
                                    </p>
                                    }
                                    {/* ----------------- GENERE ---------------------------- */}
                                    <p className='fs-5 text-success'><i>{elem.genere}</i></p>
                                    {/* ------------------ CITTA' ---------------------- */}
                                    {elem.città && <p className='mt-2'>{elem.città}</p>}
                                    {/* ------------------  TELEFONO + EMAIL ------------------- */}
                                    {elem.telefono &&
                                        <p className='mt-2' style={{ display: 'grid', gridTemplateColumns: '0.1fr 1fr', gap: '5px' }}>
                                            <p><img src={require('../image/icons8-telefono-cellulare-48.png')} width='25em' alt='' /></p>
                                            <p>{elem.telefono}</p>
                                            <p><img src={require('../image/icons8-nuovo-messaggio-48.png')} width='25em' alt='' /></p>
                                            <p>{elem.emailUser}</p>
                                        </p>
                                    }
                                    <button className='btn btn-primary mt-1' style={{ fontSize: 'small', fontWeight: '600' }} onClick={() => {
                                        dati(elem); dettagliIsOpen('fornitoriDetails')
                                    }}>Dettagli
                                    </button>
                                    <hr style={{ height: '2px', backgroundColor: 'black' }} />
                                </div>
                            )
                        })
                }
            </div>
        </div>
    </>)
}
export default CercaFornitore